import axios from "axios";
import qs from "qs";
import { Message,MessageBox,Loading } from 'element-ui';
import VueRouter from 'vue-router';
import router from '../router';

//	工具库
export const util = {


	//	配置参数
	config:{
		//	接口域名
		// host:"http://52.83.94.18:8182",
		// host:"https://localhost:8183",
		host:"https://www.yunyicha.cn",
		//	上传文件接口地址
		upload_file_api: "/api/common/upload",

	},

	//	加载效果npm
	showLoading(){

		Loading.service({
			background:"rgba(0,0,0,.3)",
			text:"加载中...",
		})

	},

	//	关闭加载效果
	hideLoading(){

		Loading.service({}).close();

	},


	//	弹窗
	alert(obj) {

		//	这个地方说白了就是 如果只是想提示一句话一个文本的话 就只是弹个小tips
		if (typeof obj == "string" || typeof obj == "number") {
			Message({
				type:"success",
				message:obj,
				duration:2000,
				showClose:false,

			});
			return;
		}

		//	标题
		obj.title = obj.title ? obj.title : "系统提示";

		//	提示内容
		obj.value = obj.value ? obj.value : "提示信息";

		//	跳转页面
		obj.url = obj.url ? obj.url : "";

		//	确定文本
		obj.confirmText = obj.confirmText ? obj.confirmText : "确定";

		//	取消按钮
		obj.cancel = obj.cancel === false ? false : true;

		//	是否关闭当前页面
		obj.close = obj.close ? obj.close : false;

		//	取消文本
		obj.cancelText = obj.cancelText ? obj.cancelText : "取消";

		//
		MessageBox({
			title:obj.title,
			message:obj.value,
			confirmButtonText:obj.confirmText,
			cancelButtonText:obj.cancelText,
			// type:"success",
			showCancelButton:obj.cancel,
			confirmButtonClass:"primary",
			showClose:false,
			closeOnClickModal:false,
			center:false,
		}).then((rs)=>{
			var res = {};
			res.confirm= true;
			obj.success ? obj.success(res) : function() {}
		}).catch((res)=>{
			var res = {};
			res.cancel = true;
			obj.success ? obj.success(res) : function() {}
		})

	},


	//	上传文件
	upload(obj) {

		//	使用promise写请求,一个函数两种回调
		return new Promise((resolve, reject) => {

			//	接口地址
			obj.url = obj.url ? obj.url : util.config.upload_file_api;

			//	文件
			obj.file = obj.file ? obj.file : "";

			//	附加数据
			obj.data = obj.data ? obj.data : {};

			//	附加token
			obj.data.token	=	uni.getStorageSync("token") ? uni.getStorageSync("token") : "";


			//
			util.showLoading();


			//	上传
			uni.uploadFile({
				url: util.config.host + obj.url,
				filePath: obj.file,
				name: 'file',
				formData: obj.data,
				dataType: 'json',
				success(res) {

					//	关闭loading效果
					util.hideLoading()

					//	成功
					obj.success ? obj.success(JSON.parse(res.data)) : function() {};

					//
					resolve(res);

				},
				fail(res) {

					util.hideLoading();

					//	错误
					obj.fail ? obj.fail(res.data) : function() {};

					//
					reject(res);

				}
			});

		})
	},

	//	发送网络请求
	request(params) {

		//	返回方法
		return new Promise((resolve, reject) => {

			var that = this;

			//	请求地址
			params.url = util.config.host + (params.url ? params.url : '');

			if(params.load){
				util.showLoading();
			}

			//	定义头部
			params.headers = {
				'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
			};

			//	定义数据
			params.data	=	params.data ? params.data : {};

			//	设置请求token
			if(localStorage.getItem("token")){
				params.headers.token = localStorage.getItem("token");
				params.data.token = localStorage.getItem("token");
			}

			//	请求方式
			params.method	=	params.method ? params.method : "POST";

			//	发送数据
			if(params.method == "POST"){
				params.data = params.data ? qs.stringify(params.data) : "";
			}else{

				//	设置get传参
				params.params = params.data;
				//	移除post类型下的data 改用params
				delete(params.data);

			}

			//	数据类型
			params.dataType = "json";

			// 发起网络请求
			axios(params).then(function(res) {

				//
				if(params.load){
					util.hideLoading();
				}

				//	帮助突破技术瓶颈，提升思维能力
				params.success ? params.success(res.data) : function() {};

				// params.load ? that.$loading().close() : "";

			})
			.catch(function(err) {

				//
				if(params.load){
					util.hideLoading();
				}

				//	如果后台提示未登录
				if(err.response && err.response.status == 401){

					//	弹窗提示
					that.$confirm('您未登录,请先登录?', '系统提示', {
						confirmButtonText: '确定',
						type: 'warning',
						showClose:false,
						showCancelButton:false,
						closeOnPressEscape:false,
						closeOnHashChange:false,
						closeOnClickModal:false,
					})
					.then(() => {
						that.$router.push("/login");
					})

					return;
				}

				params.fail ? params.fail(err) : function() {};

				// params.load ? that.$loading().close() : "";

			})
		})

	},

	//	替换图片的宽度为最大宽度100% (移动端解析html富文本专用)
	imgReplace(value, th) {

		var _self = this;

		if (!th) {
			value = value.replace(/<img src="/ig, '<img src="' + util.config.host);
		}
		return value.replace(/<p([\s\w"=\/\.:;]+)((?:(style="[^"]+")))/ig, '<p')
			.replace(/<p>/ig, '<p style="font-size: 15px; line-height: 25px;">')
			.replace(/<img([\s\w"-=\/\.:;]+)((?:(height="[^"]+")))/ig, '<img$1')
			.replace(/<img([\s\w"-=\/\.:;]+)((?:(width="[^"]+")))/ig, '<img$1')
			.replace(/<img([\s\w"-=\/\.:;]+)((?:(style="[^"]+")))/ig, '<img$1')
			.replace(/<img([\s\w"-=\/\.:;]+)((?:(alt="[^"]+")))/ig, '<img$1')
			.replace(/<img([\s\w"-=\/\.:;]+)/ig, '<img style="width: 100%;" $1');
	},

	//	get参数拼接
	setParam(data) {
		let url = '';
		for (var k in data) {
			let value = data[k] !== undefined ? data[k] : '';
			url += `&${k}=${value}`
		}
		return url ? url.substring(1) : ''
	},


	//	get参数拼接url
	setUrl(url, data) {
		return url += (url.indexOf('?') < 0 ? '?' : '') + util.setParam(data);
	},


	//	倒计时
	countDownd(endtime) {

		if (!endtime) {
			return;
		}

		var timestamp = Date.parse(new Date());

		timestamp = timestamp / 1000;

		var time = (endtime - timestamp); //距离结束的毫秒数

		// 获取天、时、分、秒
		let day = util.timeFormin(parseInt(time / (60 * 60 * 24)));
		let hou = util.timeFormin(parseInt(time % (60 * 60 * 24) / 3600));
		let min = util.timeFormin(parseInt(time % (60 * 60 * 24) % 3600 / 60));
		let sec = util.timeFormin(parseInt(time % (60 * 60 * 24) % 3600 % 60));

		var str = "";

		if (day) {
			str += day + "天";
		}

		if (hou || hou == 0) {
			if (hou > 9) {
				str += hou + ":";
			} else {
				str += "0" + hou + ":";
			}
		} else {
			str += "00:";
		}

		if (min || min == 0) {
			if (min > 9) {
				str += min + ":";
			} else {
				str += "0" + min + ":";
			}
		} else {
			str += "00:";
		}

		if (sec) {
			if (sec > 9) {
				str += sec;
			} else {
				str += "0" + sec;
			}
		} else {
			str += "00";
		}

		return str;

	},

	//	格式化时间
	timeFormin(param) {
		return param < 0 ? 0 : param;
	},

	//	获取文章
	getType: function(obj) {
		util.request({
			url: "/api/index/getArticle",
			success(rs) {
				if (rs.code == 1) {
					obj.success ? obj.success(rs) : function() {};
				} else {
					obj.error ? obj.error() : function() {};
				}
			}
		})
	},

	//	判断是否在微信中
	isWechat: function() {
		var ua = window.navigator.userAgent.toLowerCase();
		if (ua.match(/micromessenger/i) == 'micromessenger') {
			return true;
		} else {
			return false;
		}
	},

	//
	time(){
		return Date.parse(new Date())/1000;
	},


	//	微信公众号授权登录
	wechatLogin(){

		//	公众号appid
		let appid	=	util.config.wechatGroup.appid;
		//	获取当前打开过的页面路由数组
		var routes		=	getCurrentPages();
		//	获取当前页面路由
		var curRoute	=	routes[routes.length - 1].route;
		//	获取路由参数
		var curParam	=	routes[routes.length - 1].options;
		//	得到当前页面路径
		var url = location.origin + "/" + curRoute;
		//	移除参数中的code值和state  这也就意味着开发微信公众号时,页面间传值参数不能包含state和code.
		curParam.code ? delete curParam.code : "";
		curParam.state ? delete curParam.state : "";
		//	这里务必编码
		let uri		=	encodeURIComponent(util.setUrl(url,curParam));
		//	授权类型
		let scope	=	'snsapi_userinfo';
		//	静默授权只能拿到openid,如果需要静默授权就只要这个就行
		// let scope = 'snsapi_base';

		window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${uri}&response_type=code&scope=${scope}&state=123#wechat_redirect`;

	},


	//	微信注入jssdk 这个是为了开发公众号的时候才用,没事儿别瞎鸡儿用. 主要功能就是使用微信公众号所有功能 比如自定义分享,录音等等
	wechatConfig(){

		//	获取签名
		//	返回方法
		return new Promise((resolve, reject) => {

			//	发送请求
			util.request({
				url:"/addons/third/api/getWechatConfig",
			}).then((res)=>{

				//	配置微信Config
				jweixin.config({

					//	调试模式关闭
					debug: false,
					//	公众号appid
					appId: res.data.appid,
					//	时间戳
					timestamp: res.data.timestamp,
					//	字符串
					nonceStr: res.data.nonceStr,
					//	签名
					signature: res.data.signature,
					//
					jsApiList: [
						'checkJsApi',
						'onMenuShareTimeline',
						'onMenuShareAppMessage',
						'getLocation'
					]
				});

				jweixin.ready(function(){
					resolve(true);
				})

			});

		})

	},



	// 验证token是否过期
	checkToken(res){

		// 判断有没有返回的token
		if(!localStorage.getItem("token")){
			// 弹窗提示
			util.alert({
				value:'您还未登录，请先登录',
				success(rs){
					// if(rs.confirm){

						router.replace({
							path:"/",
							query:{
								login:1,
							},
						})
					// }
				}
			});
			return false;
		};

		// 请求接口 判断是否登录
		util.request({
			url: '/api/business/selectBusDictByType',
			// 上传数据
			data: {
				type: 'Category',
			},
			// get传参
			method: 'get',
			// 调用成功
			success(rs){

				// 判断token是否过期
				if(rs.code == 808){
					// 弹窗提示
					util.alert({
						value:'登录超时，请重新登录',
						success(rs){
							// if(rs.confirm){

								localStorage.removeItem("token");

								localStorage.removeItem("memberId");

								// 跳转页面
								router.replace({
									path:"/",
									query:{
										login:1,
									},
								})

							// }
						}
					});
					return false;
				}

				return res ? res(rs) :function(){};

			}
		})


	},



}

export default util;
